import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Buildings, CaretRight } from "@phosphor-icons/react";
import api, { apiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";
import { fmtDate } from "./adminUtils";

export default function AdminOrganizations() {
  const navigate = useNavigate();
  const [orgs, setOrgs] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/organizations")
      .then((r) => setOrgs(r.data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  const filtered = orgs.filter((o) =>
    !q || [o.name, o.slug].some((f) => (f || "").toLowerCase().includes(q.toLowerCase())));

  return (
    <div data-testid="admin-organizations-page">
      <PageHeader
        title="Organizations"
        subtitle="Global directory of every organization on the platform."
        action={
          <Input
            placeholder="Search name or slug…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="rounded-sm w-64"
            data-testid="admin-org-search"
          />
        }
      />

      <div className="bg-card border border-border rounded-sm overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Organization</TableHead>
              <TableHead>Slug</TableHead>
              <TableHead>Created</TableHead>
              <TableHead className="text-center">Members</TableHead>
              <TableHead>Status</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading && (
              <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">Loading…</TableCell></TableRow>
            )}
            {!loading && filtered.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">No organizations</TableCell></TableRow>
            )}
            {filtered.map((o) => (
              <TableRow
                key={o.id}
                className="cursor-pointer"
                onClick={() => navigate(`/admin/organizations/${o.id}`)}
                data-testid={`admin-org-row-${o.id}`}
              >
                <TableCell className="font-medium flex items-center gap-2">
                  <Buildings size={16} weight="bold" className="text-muted-foreground" /> {o.name}
                </TableCell>
                <TableCell className="font-mono text-xs">{o.slug || "—"}</TableCell>
                <TableCell className="text-sm">{fmtDate(o.created_at)}</TableCell>
                <TableCell className="text-center tabular-nums" data-testid={`admin-org-members-${o.id}`}>{o.member_count}</TableCell>
                <TableCell>
                  <Badge variant={o.status === "active" ? "default" : "secondary"} className="rounded-sm text-[10px] uppercase">{o.status}</Badge>
                </TableCell>
                <TableCell className="text-right text-muted-foreground"><CaretRight size={16} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
